import {
	HealthBookingEnum,
	TelehealthBookingEnum,
	OdontoBookingEnum,
	ExamBookingEnum,
	AuthorizationsEnum,
	GuidesEnum,
} from 'presentation/constants';
import {FlowEnum} from './flowEnum';

export const LOCATION_ROUTE: Record<
	Exclude<FlowEnum, FlowEnum.PROFILE | FlowEnum.SURGERY>,
	string
> = {
	[FlowEnum.HEALTH]: HealthBookingEnum.HEALTH_BOOKING_UF,
	[FlowEnum.TELEHEALTH]: TelehealthBookingEnum.TELEHEALTH_BOOKING_UF,
	[FlowEnum.ODONTO]: OdontoBookingEnum.ODONTO_BOOKING_UF,
	[FlowEnum.EXAM]: ExamBookingEnum.EXAM_BOOKING_UF,
	[FlowEnum.AUTHORIZATIONS]: AuthorizationsEnum.REQUEST_INITIAL_FLOW_UF,
	[FlowEnum.HEALTH_GUIDE]: GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_UF,
	[FlowEnum.ODONTO_GUIDE]: GuidesEnum.ODONTO_GUIDE,
};
